import { Component } from 'react';
import lodash from 'lodash';
import styles from './FilterList.scss';

export class FilterList extends Component {
    shouldComponentUpdate(nextProps) {
        if(!lodash.isEqual(this.props.listItems, nextProps.listItems)) {
            return true;
        }
        return false;
    }

    getKey(listItem) {
        const { keysForItem } = this.props;
        return lodash.chain(keysForItem)
            .map((key) => listItem[key])
            .join('-')
            .value();
    }

    render() {
        const {
            listItems,
            gotoListItem,
            removeListItem,
            accessor,
        } = this.props;

        let content;
        if (!(lodash.isNil(listItems) || lodash.isEmpty(listItems))) {
            content = lodash.map(listItems,
                li => <FilterListItem key={this.getKey(li)}
                    listItem={li}
                    accessor={accessor}
                    gotoListItem={gotoListItem}
                    removeListItem={removeListItem}/>);
        }

        return (
            <ul className={styles.list}>
                {content}
            </ul>
        );
    }
}

class FilterListItem extends Component {
    editLink(e) {
        const { gotoListItem, listItem } = this.props;
        e.preventDefault();
        if(gotoListItem){
            gotoListItem(listItem);
        }
    }

    getListActionStyle() {
        const { gotoListItem } = this.props;
        return gotoListItem ? styles.listItem__active : styles.listItem;
    }

    render() {
        const { listItem, removeListItem, accessor } = this.props;
        const listStyling = this.getListActionStyle();

        return (
            <li className={listStyling} onClick={this.editLink.bind(this)} data-cy="FilterList-render">
                <h2 className={styles.listItem__title} data-cy="FilterList-title">{listItem[accessor]}</h2>
                <RemoveListItem removeListItem={removeListItem} listItem={listItem}/>
            </li>
        );
    }
}

const RemoveListItem = ({ removeListItem, listItem }) => {
    if (lodash.isNil(removeListItem)) {
        return null;
    }

    return (
        <div className={styles.listItem__control} data-cy="FilterList-RemoveListItem">
            <button className={styles.listItem__remove} onClick={() => removeListItem(listItem)} 
                data-cy="FilterList-onClick">close</button>
        </div>
    );
};

export default FilterList;